import { Form, Input, Space, Tabs } from "antd";
import { TextEditor } from "@neonumy/ant-design";
import { useTranslation } from "react-i18next";

export default function LanguageTranslationTabs() {
  const { t } = useTranslation();

  const LANGUAGES = [
    { label: t("French"), value: "fr", flag: "🇫🇷" },
    { label: t("English"), value: "en", flag: "🇬🇧" },
    { label: t("Spanish"), value: "es", flag: "🇪🇸" },
  ];
  return (
    <Tabs
      className="antd-newrai-tabs"
      defaultActiveKey="fr"
      items={LANGUAGES.map((lang, index) => ({
        key: lang.value,
        label: `${lang.flag} ${lang.label}`,
        children: (
          <Space direction="vertical" size="small" style={{ width: "100%" }}>
            <Form.Item name={["translations", index, "language"]} hidden initialValue={lang.value}>
              <Input />
            </Form.Item>
            <Form.Item
              name={["translations", index, "name"]}
              label={t("Name")}
              rules={[{ required: true, message: t("This field is required") }]}
              style={{ marginBottom: 12 }}
            >
              <Input placeholder={t("Enter product name")} />
            </Form.Item>
            <Form.Item
              name={["translations", index, "description"]}
              label={t("Description")}
              style={{ marginBottom: 0 }}
            >
              <TextEditor allowImageUpload={false} />
            </Form.Item>
          </Space>
        ),
      }))}
    />
  );
}
